const formatter = new Intl.DateTimeFormat('en-GB', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
})

export const formatDate = (date: Date): string => formatter.format(date)
